<template>
    <div>
        <div class="home1-deco-part"></div>
        <div class="w-layout-grid footer1-bottom-grid">
            <div id="w-node-08bf2a83949a-5473b594">
                <a href="https://twitter.com/hashtag/flattenthecurve?lang=en" target="_blank" class="footer1-bottom-link">#flattenthecurve</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OctothorpeFooter"
    }
</script>

<style scoped>

</style>
